import { useEffect, useRef, useState } from "react";
import { Upload } from "lucide-react";
import { useContent } from "@/content/ContentContext";
import { imageLibrary } from "@/config/defaultImages";
import { Label } from "@/admin/ui";

// Scelta di una foto: upload (a blocchi) oppure dalla libreria delle foto già presenti.
export const ImagePicker = ({ onPick, selected }) => {
  const { upload, listUploads } = useContent();
  const [uploads, setUploads] = useState([]);
  const [progress, setProgress] = useState(null);
  const [error, setError] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    listUploads().then(setUploads).catch(() => {});
  }, [listUploads]);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setError("");
    setProgress(0);
    try {
      const url = await upload(file, setProgress);
      setUploads((u) => [url, ...u]);
      onPick(url);
    } catch (err) {
      setError(err?.response?.data?.detail || "Caricamento non riuscito");
    } finally {
      setProgress(null);
      e.target.value = "";
    }
  };

  const all = [...uploads, ...imageLibrary];

  return (
    <div data-testid="image-picker">
      <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={onFile} data-testid="image-upload-input" />
      <button
        onClick={() => inputRef.current?.click()}
        disabled={progress !== null}
        className="btn-outline !px-5 !py-2.5 !text-xs w-full justify-center"
        data-testid="image-upload-button"
      >
        <Upload className="w-3.5 h-3.5" />
        {progress === null ? "Carica una nuova foto" : `Caricamento ${progress}%`}
      </button>
      {error && <p className="mt-2 text-sm text-bordeaux">{error}</p>}
      <div className="mt-5">
        <Label>Oppure scegli dalla libreria</Label>
        <div className="grid grid-cols-4 sm:grid-cols-6 gap-2 max-h-64 overflow-y-auto pr-1" data-testid="image-library">
          {all.map((src) => (
            <button
              key={src}
              onClick={() => onPick(src)}
              className={`aspect-square overflow-hidden border-2 transition-colors ${
                selected === src ? "border-bordeaux" : "border-transparent hover:border-sand"
              }`}
              data-testid="image-library-item"
            >
              <img src={src} alt="" loading="lazy" className="w-full h-full object-cover" />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
